import styled from "@emotion/styled";

export const StyledPdfViewer = styled.div`
  .pdf-viewer-wrapper {
    display: flex;
    flex-direction: column;
    height: 90dvh;
  }

  .pdf-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .pdf-title {
    font-size: 18px;
    font-weight: 500;
    color: #262626;
  }

  .print-pdf {
    margin-right: 10px;
    .anticon {
      font-size: 20px;
    }
  }
  
  .control-group {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 12px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
  }

  .zoom-group {
    background: transparent;
    border: none;
    padding: 0;
  }

  /* Navigation Buttons */
  .nav-button,
  .zoom-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
  }

  /* Page Indicator */
  .page-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #262626;
  }

  .page-input {
    width: 50px;
    text-align: center;
    border-radius: 6px;

    .ant-input-number-input {
      text-align: center;
      font-weight: 500;
      padding: 4px 8px;
    }
  }

  .page-divider {
    color: #8c8c8c;
    font-size: 14px;
  }

  .total-pages {
    font-weight: 500;
    color: #595959;
    min-width: 20px;
  }

  /* Zoom Display */
  .zoom-display {
    min-width: 60px;
    font-weight: 500;
    color: #262626;
    border-radius: 6px;

    &:hover {
      background: #f5f5f5;
      color: #1890ff;
    }
  }

  /* PDF Document Wrapper */
  .pdf-document-wrapper {
    flex: 1;
    overflow: auto;
    background: #e8e8e8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 16px;
  }

  /* PDF Page Styles */
  .react-pdf__Document {
    display: flex;
    justify-content: center;
  }

  .react-pdf__Page {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    background: #ffffff;
    margin-bottom: 16px;

    canvas {
      border-radius: 4px;
    }
  }

  /* Loading and Error States */
  .pdf-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    color: #595959;

    p {
      margin: 16px 0 4px;
      font-size: 16px;
      font-weight: 500;
    }

    small {
      color: #8c8c8c;
      font-size: 14px;
    }

    &.error {
      color: #ff4d4f;

      small {
        color: #ff7875;
      }
    }
  }

  .page-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 600px;
  }
`;
